module.exports = __webpack_public_path__ + "static/media/Gardening.c9ffdbdf.png";